<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#FFFFFF"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <rect
      x="0.75"
      y="0.75"
      width="22.5"
      height="22.5"
      rx="11.25"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <circle
      cx="12"
      cy="12"
      r="4"
      fill="currentColor"
    />
  </svg>
</template>
